export default __webpack_public_path__ + "./image/2ceef485050edf406455bbade4badd0f.png";